import { useEffect } from 'preact/hooks';
import { theme } from '../store/theme';

export function useTheme() {
  useEffect(() => {
    if (theme.value === 'system') {
      delete document.documentElement.dataset.theme;
    } else {
      document.documentElement.dataset.theme = theme.value;
    }
  }, [theme.value]);
}
